import styled from 'styled-components';

export const Container = styled.div`
  /* pra ficar solto na tela, por cima de tudo */
  position: fixed;
  right: 0;
  bottom: 0;
  padding: 30px;
  overflow: hidden;
  z-index: 10;
`;


